import React, { Fragment, ReactNode } from 'react';
import {
  CheckboxProps,
  FormControl,
  FormControlProps,
  FormGroup,
  FormGroupProps,
} from '@mui/material';
import { Checkbox } from '../Checkbox/Checkbox';

export interface CheckboxOption {
  value: string;
  label: ReactNode;
  isChecked: boolean;
  isDisabled?: boolean;
  labelId?: string;
  checkboxId?: string;
  children?: ReactNode;
}

interface CheckboxGroupProps {
  options: CheckboxOption[];
  onToggle: (updatedOptions: CheckboxOption[]) => void;
  name: string;
  slotProps: {
    formGroup?: FormGroupProps;
    formControl: FormControlProps & { 'aria-labelledby': string };
    checkbox?: CheckboxProps;
  };
}

export const CheckboxGroup = ({ options, onToggle, name, slotProps }: CheckboxGroupProps) => {
  const handleOptionToggled = (toggledOption: CheckboxOption) => {
    const updatedOptions = options.map((option) =>
      option.value === toggledOption.value ? { ...option, isChecked: !option.isChecked } : option,
    );
    onToggle(updatedOptions);
  };

  return (
    <FormControl component="fieldset" name={name} {...slotProps.formControl}>
      <FormGroup {...slotProps.formGroup}>
        {options.map((option) => (
          <Fragment key={option.value}>
            <Checkbox
              {...slotProps?.checkbox}
              label={option.label}
              value={option.value}
              name={name}
              onChange={() => handleOptionToggled(option)}
              disabled={option.isDisabled}
              checked={option.isChecked}
              labelId={option.labelId}
              checkboxId={option.checkboxId}
            />
            {option.children}
          </Fragment>
        ))}
      </FormGroup>
    </FormControl>
  );
};
